<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Planning brigades</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color=AlertColor(type)
                 :dismissible=true
                 :value=true
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>
        <v-alert border="top" class="my-4" color="#F44336" dark dense v-if="errors.length>0"
                 v-model="alert">
          <h4 class="mt-2">{{ errors.length }}{{ " Erreur" | pluralize(errors.length) }}
            sur {{ excelData.length }} {{ "enregistrement"|pluralize(excelData.length) }}.
            Merci de corriger et de ne réimporter que les enregistrements ci-dessous rejetés, pour éviter
            tout doublon
          </h4>
          <v-row align="center">
            <v-col class="grow">
              <div :key="index" v-for="(error,index) in errors">
                <h5>
                  <v-icon>mdi-alert-circle</v-icon>
                  {{
                    "Brigade (" + error.datas.brigade + " - " +
                    formatDateRetour(error.datas.startDate) + " " +
                    formatTimeRetour(error.datas.startTime) + ") -> " + error.message
                  }}
                </h5>
              </div>
            </v-col>
            <v-col class="shrink">
              <v-btn :elevation="1" @click="closeAlert" fab small
                     style="position:absolute;top:18px;right:12px">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col>
              <v-select :disabled="disableMainBtn" :items="selectDates" @change="depthDate" dense
                        filled
                        full-width
                        hide-details="true"
                        item-text="name"
                        item-value="value" return-object solo style="z-index: 200"
                        v-model="depthVal">
                <template v-slot:selection="{ item }">
                                  <span class="d-flex justify-center" style="width: 100%;">
                                    {{ item.name }}
                                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :disabled="disableMainBtn"
                            :id="dynamicID()"
                            @change="search"
                            @keyup.native.enter="search"
                            @click:clear="cleared()"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col>
              <v-btn :disabled="disableMainBtn" @click="onexportModele" block
                     class="custom-btn white--text"
                     color="#03A9F4"
                     height="45px"
                     large>
                <v-icon class="mr-1">mdi-download-circle-outline</v-icon>
                <span>Export modèle</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn :disabled="disableMainBtn" @click="onexport" block class="custom-btn white--text"
                     color="#00BCD4"
                     height="45px"
                     large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export plannings</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-dialog class="mr-1" max-width="900px" persistent v-model="dialog">
                <template @mouseleave.native="hover = false" @mouseover.native="hover = true"
                          v-slot:activator="{ on }">
                  <v-btn :disabled="disableMainBtn" @click="initdatetime()" block
                         class="custom-btn white--text"
                         color="#009688"
                         height="45px" large
                         v-on="on">
                    <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                    <span>Nouveau planning</span>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar
                      color="#01579B"
                      dark
                      flat>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="close"
                        dark
                        fab
                        small>
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-tabs :grow=true background-color="#01579B" color="#f5f5f5" dark="" right
                          v-model="tab">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab-1"> Via un formulaire</v-tab>
                    <v-tab href="#tab-2"> Via un fichier plannings</v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tab">
                    <v-tab-item value="tab-1">
                      <v-card-text>
                        <v-container>
                          <v-row class="justify-center align-center">
                            <v-col cols="12" md="6" sm="6">
                              <v-select :items="brigadetypes"
                                        class="centered-input align-center text-center"
                                        color="#01579B" item-text="type"
                                        item-value="type"
                                        label="Brigade"
                                        prepend-inner-icon="mdi-account-group"
                                        v-model="editedItem.brigade">
                                <template v-slot:selection="{ item }">
                                                                  <span class="d-flex justify-center"
                                                                        style="width: 100%;">
                                                                    {{ item }}
                                                                  </span>
                                </template>
                              </v-select>
                            </v-col>
                            <v-col cols="12" md="6" sm="6">
                              <v-select :items="shifts"
                                        @change="loadDateTimeShift"
                                        class="centered-input align-center text-center"
                                        color="#01579B"
                                        item-text="type"
                                        item-value="type"
                                        label="Shifts"
                                        prepend-inner-icon="mdi-selection-ellipse-arrow-inside"
                                        v-model="editedItem.shiftName">
                                <template v-slot:selection="{ item }">
                                                                  <span class="d-flex justify-center"
                                                                        style="width: 100%;">
                                                                    {{ item }}
                                                                  </span>
                                </template>
                              </v-select>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="6" sm="6">
                              <v-menu
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  min-width="290px"
                                  offset-y
                                  transition="scale-transition"
                                  v-model="menu1"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Date début Shift"
                                                persistent-hint
                                                prepend-inner-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-model="computedDateFormatted1"
                                                v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                    :disabled="isdisabled"
                                    @change="loadEndDateShift"
                                    @input="menu1=false"
                                    locale="fr-FR"
                                    v-model="editedItem.startDate"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" md="6" sm="6">
                              <v-dialog
                                  :return-value.sync="editedItem.startTime"
                                  persistent
                                  ref="dialog"
                                  v-model="modal2"
                                  width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                disabled
                                                label="Heure début Shift"
                                                prepend-inner-icon="access_time"
                                                readonly
                                                v-bind="attrs"
                                                v-model="computedDateFormatted11"
                                                v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                    :useSeconds=true
                                    format="24hr"
                                    full-width
                                    v-if="modal2"
                                    v-model="editedItem.startTime"
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn @click="modal2 = false" color="primary" text>
                                    Annuler
                                  </v-btn>
                                  <v-btn @click="$refs.dialog.save(editedItem.startTime)"
                                         color="primary"
                                         text>
                                    Valider
                                  </v-btn>
                                </v-time-picker>
                              </v-dialog>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="6" sm="6">
                              <v-menu
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  min-width="290px"
                                  offset-y
                                  transition="scale-transition"
                                  v-model="menu2"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                disabled
                                                label="Date fin Shift"
                                                persistent-hint
                                                prepend-inner-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-model="computedDateFormatted2"
                                                v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                    @input="menu2= false"
                                    locale="fr-FR"
                                    v-model="editedItem.endDate"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" md="6" sm="6">
                              <v-dialog
                                  :return-value.sync="editedItem.endTime"
                                  persistent
                                  ref="dialog3"
                                  v-model="modal3"
                                  width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                disabled
                                                label="Heure fin Shift"
                                                prepend-inner-icon="access_time"
                                                readonly
                                                v-bind="attrs"
                                                v-model="computedDateFormatted22"
                                                v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                    :useSeconds=true
                                    format="24hr"
                                    full-width
                                    v-if="modal3"
                                    v-model="editedItem.endTime"
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn @click="modal3 = false" color="primary" text>
                                    Annuler
                                  </v-btn>
                                  <v-btn @click="$refs.dialog3.save(editedItem.endTime)"
                                         color="primary"
                                         text>
                                    Valider
                                  </v-btn>
                                </v-time-picker>
                              </v-dialog>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="!FormIsValid && !loading" @click="creer"
                               class="white--text"
                               color="#01579B" depressed>Créer planning
                        </v-btn>
                      </v-card-actions>
                    </v-tab-item>
                    <v-tab-item value="tab-2">
                      <v-card v-if="!file">
                        <v-container v-if="loading">
                          <div class="text-center">
                            <v-progress-circular color="green" indeterminate>
                            </v-progress-circular>
                          </div>
                        </v-container>
                        <v-btn :disabled="!fileBtn" @click="onPickFile" block
                               class="mr-2 mb-2"
                               large style="color:#01579B; background-color:#F5F5F5"
                               v-if="!loading">
                          <v-icon>mdi-paperclip</v-icon>
                          Importer ICI ou Glisser/Copier le fichier Excel ci-dessous
                        </v-btn>
                        <input @change="onFilePicked($event)" accept="xlsx/*" id="upload"
                               ref="fileInput"
                               style="display:none" type="file"/>
                      </v-card>
                      <v-card>
                        <div class="text-center">
                          <v-card-text>
                            <v-chip color="white" disabled label small
                                    v-if="file">
                              {{ file.name }} ({{ file.size | kb }} kb)
                            </v-chip>
                            <v-btn @click="removeFile(file)"
                                   title="Supprimer"
                                   v-if="file">
                              <v-icon style="color:orangered;">
                                mdi-delete-circle-outline
                              </v-icon>
                            </v-btn>
                            <template>
                              <div ref="others">
                                <div :class="['downbox', drag_over ? 'over' : '']"
                                     @dragenter="dragEnter"
                                     @dragleave="dragLeave"
                                     @dragover.prevent
                                     @drop.prevent="addFile"
                                     @ondragover="dragOver"
                                     v-cloak>
                                  <v-btn
                                      color="primary"
                                      height="100px"
                                      outlined
                                      v-if="!file"
                                      width="100%"
                                  >
                                  </v-btn>
                                </div>
                              </div>
                              <v-spacer></v-spacer>
                              <v-btn :disabled="loading" :loading="loading"
                                     @click.prevent="importFileToHandsonTableBrigades"
                                     color="#009688" dark
                                     depressed
                                     fab
                                     v-if="file">
                                <v-icon>mdi-cloud-upload</v-icon>
                                <span class="custom-loader" slot="loader">
                                                                        <v-icon color="white" light>cached</v-icon>
                                                                        </span>
                              </v-btn>
                            </template>
                          </v-card-text>
                        </div>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import {depthDate} from "../../../helper/profondeur";
import * as XLSX from 'xlsx';
import Handsontable from "handsontable";
import Vue from "vue";

function customDropDownRender(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.AutocompleteRenderer.apply(this, arguments);
  cellProperties.data = 'options';
  cellProperties.type = 'dropdown';

  if (col === 1) {
    cellProperties.source = JSON.parse(sessionStorage.getItem("Brigades"));
  }
}

function customDropDownRender2(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.AutocompleteRenderer.apply(this, arguments);
  cellProperties.data = 'options';
  cellProperties.type = 'dropdown';

  if (col === 2) {
    cellProperties.source = JSON.parse(sessionStorage.getItem("Shifts"));
  }
}

Vue.filter('kb', val => {
  return Math.floor(val / 1024);
});

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "PlanningBrigades",
  components: {HotTable},
  data: function () {
    return {
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      searchName: "",
      fileBtn: true,
      drag_over: false,   // dragging over the target OR any child element
      over_others: false, // dragging over a child element
      files: [],
      lastHighlitedRow: null,
      isdisabled: true,
      menu1: null,
      menu2: null,
      type: null,
      elapse: null,
      loading: false,
      loading2: false,
      modal2: false,
      modal3: false,
      startTimeShit: "",
      endTimeShift: "",
      toObject: [],
      selectDates: depthDate,
      depthVal: {
        name: sessionStorage.getItem("depthValChoosedt"),
        value: sessionStorage.getItem("depthValChoosedd")
      },
      editedItem: {
        brigade: "",
        shiftName: "",
        startDate: "",
        startTime: "",
        endDate: "",
        endTime: "",
      },
      tab: null,
      dialog: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      file: "",
      editedIndex: -1,
      errors: [],
      excelData: [],
      brigadetypes: [],
      shifts: [],
      shiftsFull: [],
      arrayAbs: [],
      months: {
        '01': 'Janvier',
        '02': 'Février',
        '03': 'Mars',
        '04': 'Avril',
        '05': 'Mai',
        '06': 'Juin',
        '07': 'Juillet',
        '08': 'Août',
        '09': 'Septembre',
        '10': 'Octobre',
        '11': 'Novembre',
        '12': 'Décembre'
      },
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        contextMenu: ["remove_row"],
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: true,
        afterChange: this.afterChangeMe,
        beforeRemoveRow: this.beforeRemoveRowMe,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        comment: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0],
          indicators: false
        },
        colHeaders:
            ["Id", "Brigade", "Nom Shift", "Jour début Shift", "Heure début Shift", "Jour fin Shift", "Heure fin Shift", "Mois", "Année"],
        columns: [
          {title: "Id", width: "80px"},
          {
            title: "Brigade",
            width: "160px",
            type: "dropdown",
            renderer: customDropDownRender,
            allowInvalid: false,
            strict: true
          },
          {
            title: "Nom Shift",
            width: "160px",
            type: "dropdown",
            renderer: customDropDownRender2,
            allowInvalid: false,
            strict: true
          },
          {
            title: "Jour début Shift",
            width: "180px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true,
            readOnly: true
          },
          {
            title: "Heure début Shift",
            width: "180px",
            type: "time",
            timeFormat: "HH:mm:ss",
            correctFormat: true,
            readOnly: true
          },
          {
            title: "Jour fin Shift",
            width: "180px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true,
            readOnly: true
          },
          {
            title: "Heure fin Shift",
            width: "180px",
            type: "time",
            timeFormat: "HH:mm:ss",
            correctFormat: true,
            readOnly: true
          },
          {title: "Mois", width: "100px"},
          {title: "Année", width: "100px"}
        ]
      }
    }
  },

  created() {
    this.loadBrigades()
    this.loadShifts()
    this.getData(this.depthVal)
  },

  computed: {
    FormIsValid() {
      return (
          this.editedItem.brigade !== "" &&
          this.editedItem.shiftName !== "" &&
          this.editedItem.startDate !== "" &&
          this.editedItem.startTime !== "" &&
          this.editedItem.endDate !== "" &&
          this.editedItem.endTime !== ""
      );
    },

    computedDateFormatted1() {
      return this.formatDate(this.editedItem.startDate)
    },

    computedDateFormatted2() {
      return this.formatDate(this.editedItem.endDate)
    },

    computedDateFormatted11() {
      return this.formatTime(this.editedItem.startTime)
    },

    computedDateFormatted22() {
      return this.formatTime(this.editedItem.endTime)
    },
  },

  methods: {
    cleared() {
      this.searchName = "";
      this.getData();
    },
    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase()

      if (this.isEmpty(query)) {
        this.cleared()
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 1, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },
    dragEnter(e) {
      if (e.target === this.$refs.others)
        this.over_others = true
      else
        this.drag_over = true
    },
    dragOver(e) {
      if (e.target === this.$refs.others) this.over_others = true
      else this.drag_over = true
    },
    dragLeave(e) {
      if (e.target === this.$refs.others) this.over_others = false
      else if (!this.over_others) this.drag_over = false
    },
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    loadBrigades() {
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/brigadetypes/` + sessionStorage.getItem("userId"), {timeout: 180000}
          )
          .then(response => {
            sessionStorage.setItem("Brigades", null)
            let datas = response.data.datas;
            this.brigadetypes = []
            datas.forEach(item => {
              if (item.type.toUpperCase().toLocaleString() !== "INACTIF") {
                this.brigadetypes.push(item.type);
              }
            });
            sessionStorage.setItem("Brigades", JSON.stringify(this.brigadetypes))
          })
          .catch(() => {
          });
    },
    loadShifts() {
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/shifts/` + sessionStorage.getItem("userId"), {timeout: 180000}
          )
          .then(response => {
            sessionStorage.setItem("Shifts", null)
            let datas = response.data.datas;
            this.shiftsFull = datas;
            this.shifts = []
            datas.forEach(item => {
              this.shifts.push(item.shiftName);
            });
            sessionStorage.setItem("Shifts", JSON.stringify(this.shifts))
          })
          .catch(() => {
          });
    },
    loadDateTimeShift() {
      this.editedItem.startDate = "";
      this.editedItem.endDate = "";

      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/shifts/` + sessionStorage.getItem("userId"), {timeout: 180000}
          )
          .then(response => {
            let datas = response.data.datas;
            this.shifts = [];
            this.shiftsFull = datas;
            datas.forEach(item => {
              this.shifts.push(item.shiftName);
              if (item.shiftName === this.editedItem.shiftName) {
                this.editedItem.startTime = item["startTime"];
                this.editedItem.endTime = item["endTime"];
              }
            });

            this.isdisabled = false;
          })
          .catch(() => {
            this.isdisabled = true;
          });
    },
    getStartTimeShift(shiftName) {
      let result = "";
      this.shiftsFull.forEach(item => {
        if (item.shiftName === shiftName) {
          result = item.startTime;
        }
      });

      return result;
    },
    getEndTimeShift(shiftName) {
      let result = "";
      this.shiftsFull.forEach(item => {
        if (item.shiftName === shiftName) {
          result = item.endTime;
        }
      });

      return result;
    },
    loadEndDateShift() {
      //https://www.npmjs.com/package/dateformat
      let stimeS = this.editedItem.startTime
      stimeS = stimeS.split(':');
      let sectimeS = parseInt(stimeS[0] * 3600 + stimeS[1] * 60 + stimeS[0]);

      let stimeE = this.editedItem.endTime
      stimeE = stimeE.split(':');
      let sectimeE = parseInt(stimeE[0] * 3600 + stimeE[1] * 60 + stimeE[0]);

      if (sectimeS <= sectimeE) {
        this.editedItem.endDate = this.editedItem.startDate
      } else {
        var dateFormat = require('dateformat');
        let day, month, year;
        day = this.getDay(this.editedItem.startDate)
        month = this.getMonth(this.editedItem.startDate)
        year = this.getYear(this.editedItem.startDate)

        let sDatetimeS = new Date(year, month - 1, day)
        var oneDayInMilliseconds = 86400000;
        let sDatetimeE = new Date(sDatetimeS.getTime() + oneDayInMilliseconds)
        //this.editedItem.endDate = dateFormat(sDatetimeE, "yyyy-mm-dd");
        this.editedItem.endDate = moment(sDatetimeE).format("YYYY-MM-DD")
      }
    },
    initdatetime() {
      this.tab = "tab-1";
      this.editedItem.brigade = "";
      this.editedItem.shiftName = "";
      this.editedItem.startDate = "";
      this.editedItem.startTime = "";
      this.editedItem.endTime = "";
      this.editedItem.startTime = "";
      this.files = [];
      this.fileBtn = true;
      this.file = "";
      this.drag_over = false;
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    formatDateRetour(date) {
      if (!date) return null
      let datetmp = moment(date, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD")
      const [year, month, day] = datetmp.split('-')

      return `${day}/${month}/${year}`
    },
    getDay(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}`
    },
    getMonth(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}`
    },
    getYear(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${year}`
    },
    formatTime(time) {
      if (!time) return null

      const [hh, mm, ss] = time.split(':')
      return `${hh}:${mm}:${ss}`
    },
    formatTimeRetour(time) {
      if (!time) return null

      let timetmp = moment(time, "YYYY-MM-DD HH:mm:ss").format("HH:mm:ss")
      const [hh, mm, ss] = timetmp.split(':')

      return `${hh}:${mm}:${ss}`
    },
    depthDate() {
      if (this.depthVal) {
        sessionStorage.setItem("depthValChoosedd", this.depthVal.value)
        sessionStorage.setItem("depthValChoosedt", this.depthVal.name)
      }
      this.getData(this.depthVal)
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    pad(n, width, z) {
      z = z || '0';
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    },
    getData(valeur) {
      this.loading = true
      valeur = this.depthVal.value
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/planningbrigadesbydatedepth/` + moment().subtract(valeur, "days").format("YYYY-MM-DD") + "/" + sessionStorage.getItem("userId"), {timeout: 180000}
          )
          .then(response => {
            this.loading = false
            let tabArray = []
            let newObj = response.data.datas;

            if (response.data.status !== 200) {
              this.color = "#009688"
              this.text = response.data.message;
              this.showAlert('warning')
              this.disableMainBtn = true
            } else {
              this.disableMainBtn = false
            }

            String.prototype.capitalize = function (allWords) {
              return (allWords) ? // if all words
                  this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                  this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
            }

            newObj.forEach((item) => {
              tabArray.push([
                item["id"],
                this.isEmpty(item["brigade"]) ? "" : item["brigade"].toUpperCase(),
                item["shiftName"],
                this.convertDate(item["startDate"]),
                item["startTime"],
                this.convertDate(item["endDate"]),
                item["endTime"],
                this.months[this.pad(this.getMonth(item["startDate"]), 2)],
                this.getYear(item["startDate"])
              ])
            })

            this.$refs.hotTable.hotInstance.loadData(tabArray)
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
          })
          .catch(() => {
            this.loading = false
          });
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData(this.depthVal)
    },
    datefull(val) {
      if (!val) {
        return
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    convertDate(val) {
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY");
    },
    close() {
      this.dialog = false;
      this.file = "";
      this.initEditedItem();
      this.files = []
      this.fileBtn = true;
      this.drag_over = false;
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    closeAlert() {
      this.alert = false
      this.text = ""
      this.errors = []
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    initEditedItem() {
      this.editedItem.brigade =
          this.editedItem.startDate =
              this.editedItem.shiftName =
                  this.editedItem.startTime =
                      this.editedItem.endDate =
                          this.editedItem.endTime = "";
    },
    afterChangeMe(changes, source) {
      if (changes !== null && source === "edit" && (changes[0][2] !== changes[0][3])) {
        let message = {
          title: 'Fenêtre de confirmation',
          body: 'Confirmez la modification du planning de la brigade.'
        };

        this.$dialog
            .confirm(message)
            .then(dialog => {
              this.loading = true
              let obj = {}
              let newObj = {}

              obj = this.$refs.hotTable.hotInstance.getData()[changes[0][0]]

              let sdate = moment(obj[3], "DD-MM-YYYY").format("YYYY-MM-DD HH:mm:ss")
              let stime = moment(obj[4], "HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
              let edate = moment(obj[5], "DD-MM-YYYY").format("YYYY-MM-DD HH:mm:ss")
              let etime = moment(obj[6], "HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")

              newObj = {
                "id": obj[0],
                "brigade": obj[1],
                "shift": obj[2],
                "startDate": sdate,
                "startTime": stime,
                "endDate": edate,
                "endTime": etime,
              }

              apiClient
                  .post(
                      `${this.$store.getters.user.baseUrl}/account/planningbrigade/` +
                      sessionStorage.getItem("userId"),
                      newObj
                  )
                  .then(res => {
                    dialog.close();
                    this.loading = false
                    this.dialog = false;
                    if (res.data.status === 200) {
                      this.color = "#009688"
                      this.text = res.data.message;
                      this.showAlert('info')
                      this.depthDate()
                      this.initEditedItem()
                    } else {
                      this.alert = true
                      this.color = "#F44336"
                      this.text = res.data.message;

                      let myData = this.$refs.hotTable.hotInstance.getData()
                      myData[changes[0][0]][changes[0][1]] = changes[0][2]
                      this.$refs.hotTable.hotInstance.loadData(myData)
                      this.showAlert('warning')
                    }
                  })
                  .catch((err) => {
                    dialog.close();
                    this.dialog = false;
                    let myData = this.$refs.hotTable.hotInstance.getData()
                    myData[changes[0][0]][changes[0][1]] = changes[0][2]
                    this.$refs.hotTable.hotInstance.loadData(myData)

                    this.alert = true
                    this.color = "#F44336"
                    this.text = err.data.message;
                    this.loading = false
                    this.showAlert('warning')
                  });
            })
            .catch(() => {
              let myData = this.$refs.hotTable.hotInstance.getData()
              myData[changes[0][0]][changes[0][1]] = changes[0][2]
              this.$refs.hotTable.hotInstance.loadData(myData)
            });
      }
    },

    beforeRemoveRowMe(index, amount) {
      let rowId = this.$refs.hotTable.hotInstance.getData()[index]
      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez la suppression du planning de la brigade.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true

            apiClient
                .delete(
                    `${this.$store.getters.user.baseUrl}/account/planningbrigade/` + rowId[0] + "/false/" + sessionStorage.getItem("userId")
                )
                .then(res => {
                  dialog.close();
                  this.loading = false
                  if (res.data.status === 200) {
                    this.color = "#009688"
                    this.text = res.data.message;
                    this.showAlert('info')
                  } else if (res.data.status === 426) {
                    let message = {
                      title: 'Fenêtre de confirmation',
                      body: `${res.data.message}`
                    };

                    this.$dialog
                        .confirm(message)
                        .then(dialog => {
                          apiClient.delete(
                                  `${this.$store.getters.user.baseUrl}/account/planningbrigade/` + rowId[0] + "/true/" + sessionStorage.getItem("userId")
                              )
                              .then(res => {
                                dialog.close();
                                this.loading = false
                                if (res.data.status === 200) {
                                  this.color = "#009688"
                                  this.text = res.data.message;
                                  this.showAlert('info')
                                } else {
                                  this.$refs.hotTable.hotInstance.alter("insert_row_above", index)
                                  this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
                                  this.$refs.hotTable.hotInstance.setCellMeta(index, 1, "readOnly", false);
                                  this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
                                  this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
                                  this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", false);
                                  this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", false);
                                  this.$refs.hotTable.hotInstance.setCellMeta(index, 6, "readOnly", false);
                                  this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", false);
                                  this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", false);
                                  this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", false);
                                  this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);
                                  this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
                                  this.$refs.hotTable.hotInstance.setCellMeta(index, 1, "readOnly", true);
                                  this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", true);
                                  this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", true);
                                  this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", true);
                                  this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", true);
                                  this.$refs.hotTable.hotInstance.setCellMeta(index, 6, "readOnly", true);
                                  this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", true);
                                  this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", true);
                                  this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", true);

                                  this.color = "#F44336"
                                  this.alert = true
                                  this.text = res.data.message;
                                  this.showAlert('warning')
                                }
                              })
                              .catch((error) => {
                                dialog.close();
                                this.loading = false
                                this.alert = true
                                this.color = "#F44336"
                                this.text = error;
                                this.showAlert('warning')
                              });
                        })
                        .catch(() => {
                          this.$refs.hotTable.hotInstance.alter("insert_row_above", index)
                          this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
                          this.$refs.hotTable.hotInstance.setCellMeta(index, 1, "readOnly", false);
                          this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
                          this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
                          this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", false);
                          this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", false);
                          this.$refs.hotTable.hotInstance.setCellMeta(index, 6, "readOnly", false);
                          this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", false);
                          this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", false);
                          this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", false);
                          this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);
                          this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
                          this.$refs.hotTable.hotInstance.setCellMeta(index, 1, "readOnly", true);
                          this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", true);
                          this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", true);
                          this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", true);
                          this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", true);
                          this.$refs.hotTable.hotInstance.setCellMeta(index, 6, "readOnly", true);
                          this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", true);
                          this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", true);
                          this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", true);

                          this.color = "#F44336"
                          this.alert = true
                          this.text = "La commande 'SUPPRIMER BRIGADE' a été annulée.";
                          this.showAlert('info')
                        });
                  } else {
                    this.$refs.hotTable.hotInstance.alter("insert_row_above", index)
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 1, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 6, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", false);
                    this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 1, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 6, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", true);

                    this.color = "#F44336"
                    this.alert = true
                    this.text = res.data.message;
                    this.showAlert('warning')
                  }
                })
                .catch((error) => {
                  dialog.close();
                  this.loading = false
                  this.alert = true
                  this.color = "#F44336"
                  this.text = error;
                  this.showAlert('warning')
                });
          })
          .catch(() => {
            this.$refs.hotTable.hotInstance.alter("insert_row_above", index)
            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 1, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 6, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", false);
            this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 1, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 6, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", true);
          });
    },
    onFilePicked(e) {
      const files = e.target.files;
      this.file = this.$refs.fileInput.files[0];
      if (!files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.text = "Le format du fichier est incorrecte.\nMerci de choisir un format xls ou xlsx";
        this.showAlert('warning');
        return false;
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0];
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {defval: "", skipHidden: true});
          const excellist = [];
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          }
          this.total = excellist
              .map(item => item.montant)
              .reduce((prev, curr) => prev + curr, 0);
          this.excelData = excellist.map(function (item) {
            return Object.values(item);
          })
        } catch (e) {
          this.text = "Erreur de lecture du fichier !";
          this.showAlert('warning')
          return false;
        }
      }
      fileReader.readAsBinaryString(files[0]);
      const input = document.getElementById("upload");
      input.value = "";
    },
    creer() {
      this.loading = true

      const dataToSave = {
        brigade: this.editedItem.brigade,
        shiftName: this.editedItem.shiftName,
        startDate: moment(this.editedItem.startDate).format("YYYY-MM-DD HH:mm:ss"),
        startTime: moment(this.editedItem.startTime, "HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
        endDate: moment(this.editedItem.endDate).format("YYYY-MM-DD HH:mm:ss"),
        endTime: moment(this.editedItem.endTime, "HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
      };
      apiClient
          .post(`${this.$store.getters.user.baseUrl}/account/planningbrigade/` + sessionStorage.getItem("userId"),
              dataToSave
          )
          .then(res => {
            this.dialog = false;
            this.loading = false
            if (res.data.status === 200) {
              this.color = "#009688"
              this.text = res.data.message
              this.initEditedItem()
              this.showAlert('info')
              this.depthDate();
            } else {
              this.color = "#F44336"
              this.alert = true
              this.text = res.data.message;

              this.showAlert('warning')
              this.depthDate();
            }
          })
          .catch(error => {
            this.dialog = false;
            this.alert = true
            this.text = error;
            this.loading = false
            this.color = "#F44336"
            this.showAlert('warning')
          });
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    importFileToHandsonTableBrigades() {
      let vm = this;
      vm.loading = true
      this.file = ""
      vm.dialog = false;
      let dataTosave = [];

      var oneDayInMilliseconds = 86400000;
      const fromExcelDate = require("js-excel-date-convert").fromExcelDate;

      let stimeS, sectimeS, stimeE, sectimeE
      let sdate, stime, edate, etime
      let sDatetimeS, sDatetimeE
      let day, month, year;

      for (let i = 0; i < this.excelData.length; i++) {
        sdate = moment(fromExcelDate(this.excelData[i][2])).format("YYYY-MM-DD HH:mm:ss")

        stime = this.getStartTimeShift(this.excelData[i][1])
        etime = this.getEndTimeShift(this.excelData[i][1])

        stimeS = stime
        stimeS = stimeS.split(':');
        sectimeS = parseInt(stimeS[0] * 3600 + stimeS[1] * 60 + stimeS[0]);

        stimeE = etime
        stimeE = stimeE.split(':');
        sectimeE = parseInt(stimeE[0] * 3600 + stimeE[1] * 60 + stimeE[0]);

        if (sectimeS <= sectimeE) {
          edate = moment(fromExcelDate(this.excelData[i][2])).format("YYYY-MM-DD HH:mm:ss")
        } else {
          day = this.getDay(moment(fromExcelDate(this.excelData[i][2])).format("YYYY-MM-DD"))
          month = this.getMonth(moment(fromExcelDate(this.excelData[i][2])).format("YYYY-MM-DD"))
          year = this.getYear(moment(fromExcelDate(this.excelData[i][2])).format("YYYY-MM-DD"))

          sDatetimeS = new Date(year, month - 1, day)
          sDatetimeE = new Date(sDatetimeS.getTime() + oneDayInMilliseconds)
          edate = moment(sDatetimeE).format("YYYY-MM-DD HH:mm:ss")
        }

        if ((sdate === "Invalid date") || (stime === "Invalid date") || (edate === "Invalid date") || (etime === "Invalid date")) {
          this.text = "Date & Heure invalide -> Ligne " + (i + 2) +
              ".\nLes dates doivent être au format DATE et les heures au format HEURE (cf modèle)."
          this.showAlert('warning')
          vm.loading = false;
          return;
        }

        stime = "1970-01-01 " + stime
        etime = "1970-01-01 " + etime

        dataTosave.push({
          brigade: this.excelData[i][0],
          shiftName: this.excelData[i][1],
          startDate: sdate,
          startTime: stime,
          endDate: edate,
          endTime: etime,
          originUser: sessionStorage.getItem("userId")
        });
      }

      apiClient
          .post(
              `${vm.$store.getters.user.baseUrl}/account/planningbrigades/` +
              sessionStorage.getItem("userId"),
              dataTosave
          )
          .then(res => {
            vm.loading = false
            if (res.data.status === 200) {
              let dataObj = [];
              let dataError = []
              for (let i = 0; i < res.data.datas.length; i++) {
                if (res.data.datas[i].status === 200) {
                  dataObj.push(res.data.datas[i].datas);
                } else {
                  dataError.push(res.data.datas[i]);
                }
              }

              if (dataObj.length > 0 && dataError.length === 0) {
                vm.color = "#009688"
                vm.text = dataObj.length + " Planning(s) ajouté(s).";
                vm.file = "";
                this.showAlert('info')
                this.depthDate()
              } else if (dataObj.length === 0 && dataError.length > 0) {
                vm.alert = true
                vm.color = "#F44336"
                vm.errors = dataError
                vm.file = "";
                this.depthDate()
              } else if (dataObj.length > 0 && dataError.length > 0) {
                vm.color = "#F44336"
                vm.errors = dataError
                vm.file = "";
                vm.alert = true
                this.depthDate()
              }
            } else {
              this.alert = true
              this.color = "#F44336"
              this.text = res.data.message;
              this.showAlert('warning')
            }
          })
          .catch(err => {
            vm.loading = false
            vm.alert = true
            vm.text = err;
            vm.color = "#F44336"
            this.showAlert('warning')
          });
    },

    onexport() { // On Click Excel download button
      // export json to Worksheet of Excel
      // only array possible
      this.loading = true
      var datas = XLSX.utils.json_to_sheet(this.toObject, {skipHeader: true})
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, datas, "Planning_brigades") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Planning_brigades.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    },

    onexportModele() { // On Click Excel download button
      this.loading = true;

      // Modele brigades
      var ws = XLSX.utils.json_to_sheet([
        {
          brigade: "Brigade",
          shiftName: "Nom Shift",
          startDate: "Jour début Shift"
        },
        {
          brigade: "XXX-BRG-Y",
          shiftName: "APREM_15H_02H",
          startDate: "12/03/2030"
        },
      ], {
        header: ["brigade", "shiftName", "startDate"],
        skipHeader: true,
        cellDates: true
      });

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, ws, "Planning_brigades") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Planning_brigades_modèle.xlsx", {cellDates: true}) // name of the file is "book.xlsx"

      this.loading = false
    },
    addFile(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
      ([...droppedFiles]).forEach(f => {
        this.files.push(f);
      });

      let formData = new FormData();
      this.files.forEach((f, x) => {
        formData.append('file' + (x + 1), f);
      });

      if (!this.files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(this.files[0].name.toLowerCase())) {
        this.text = "Le format du fichier est incorrecte.\nMerci de choisir un format xls ou xlsx";
        this.showAlert('warning');
        return false;
      } else if (this.files.length !== 1) {
        this.text = "Nous ne traitons qu'un fichier excel";
        this.showAlert('warning');
        return false;
      }

      this.file = this.files[0];
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0];
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {defval: "", skipHidden: true});
          const excellist = [];
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          }
          this.total = excellist
              .map(item => item.montant)
              .reduce((prev, curr) => prev + curr, 0);
          this.excelData = excellist.map(function (item) {
            return Object.values(item);
          })

          this.fileBtn = false;
        } catch (e) {
          this.text = "Erreur de lecture du fichier !";
          this.showAlert('warning')
          return false;
        }
      }
      fileReader.readAsBinaryString(this.file);
      const input = document.getElementById("upload");
      input.value = "";
    },
    removeFile(file) {
      this.loading = false
      this.fileBtn = true
      this.drag_over = false
      this.file = ""
      this.files = this.files.filter(f => {
        return f !== file;
      });
    },
  },
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

.pre-formatted {
  white-space: pre;
}
</style>
 
